import { render, staticRenderFns } from "./SetDataResult.vue?vue&type=template&id=50d4c4cf&"
import script from "./SetDataResult.vue?vue&type=script&lang=js&"
export * from "./SetDataResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports